

export default {
    label: 'Languages',
    name: 'languages',
    file: 'src/content/settings/language.json',
    format: 'json',
    i18n: false,
    fields: [
        {
            label: 'Language',
            name: 'languages',
            widget: 'list',
            fields: [
                {
                    label: 'Name',
                    name: 'name',
                    widget: 'string',
                },
                {
                    label: 'Code',
                    name: 'code',
                    widget: 'string',
                },
                {
                    label: 'Flag',
                    name: 'flag',
                    widget: 'select',
                    options: [
                            "🇺🇸",
                            "🇦🇱", "🇦🇩", "🇦🇲", "🇦🇹", "🇧🇾", "🇧🇪", "🇧🇦", "🇧🇬", "🇭🇷", "🇨🇾", "🇨🇿", "🇩🇰", 
                            "🇪🇪", "🇫🇮", "🇫🇷", "🇬🇪", "🇩🇪", "🇬🇷", "🇭🇺", "🇮🇸", "🇮🇪", "🇮🇹", "🇽🇰", "🇱🇻", 
                            "🇱🇮", "🇱🇹", "🇱🇺", "🇲🇹", "🇲🇩", "🇲🇨", "🇲🇪", "🇳🇱", "🇲🇰", "🇳🇴", "🇵🇱", "🇵🇹", 
                            "🇷🇴", "🇷🇺", "🇸🇲", "🇷🇸", "🇸🇰", "🇸🇮", "🇪🇸", "🇸🇪", "🇨🇭", "🇺🇦", "🇬🇧", "🇻🇦"
                    ]
                },
            ],
        }
    ],
};